import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/copyright-link.css.js";
import { ExternalLink } from "components/link";

const CopyrightLink = ({ children, classes, url }) => (
  <ExternalLink href={url} className={classes.footerLink}>
    {children}
  </ExternalLink>
);

CopyrightLink.propTypes = {
  /**
   * Url del enlace
   */
  url: PropTypes.string,
};

export default withStyles(styles)(CopyrightLink);
